import * as login from "./login";
import * as theme from "./theme";
import * as sidebar from "./sidebar";

export default {
	login,
	theme,
	sidebar
};
